export const CONDENSED_PDP_TRAFFIC_TEST_NAME = 'condensedPdpTraffic';

export const isPaidTraffic = (url: string | undefined): boolean => {
    const queryString = (url || '').split('?')?.[1];

    if (!queryString) {
        return false;
    }

    const searchParams = new URLSearchParams(queryString);

    return !!(searchParams.get('gad_source')?.toLowerCase() === '1');
};
